// extracted by mini-css-extract-plugin
module.exports = {"createTourContainer":"CreateTour_createTourContainer__2fess","createTourBody":"CreateTour_createTourBody__1cZ8G"};